var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57082 3.05756C2.58999 2.86423 2.51666 2.67173 2.37082 2.54173L0.895822 0.764225V0.497559H5.47749L9.01916 8.26423L12.1325 0.497559H16.5V0.763392L15.2375 1.97256C15.1292 2.05589 15.0767 2.19256 15.0975 2.32673V11.2151C15.0767 11.3501 15.1292 11.4859 15.2375 11.5692L16.47 12.7784V13.0442H10.2733V12.7784L11.5475 11.5392C11.6742 11.4142 11.6742 11.3767 11.6742 11.1859V4.00089L8.12499 13.0151H7.64582L3.51416 4.00089V10.0417C3.47999 10.2959 3.56416 10.5517 3.74332 10.7359L5.40332 12.7501V13.0159H0.696655V12.7501L2.35666 10.7359C2.53332 10.5517 2.61332 10.2942 2.57082 10.0417V3.05756Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon);
export default __webpack_public_path__ + "static/media/m-icon.61a19a1977221de51965c9296b82f16c.svg";
export { ForwardRef as ReactComponent };